import { readJson } from './apiResponse';

var getUnreadMessagesFromDatabase = () => {
    return dispatch => {
        const token = localStorage.token;
        if (token) {
            return fetch("api/UnreadMessageUser/List", {
                method: "POST",
                headers: {
                    'Content-Type': 'application/json',
                    Accept: 'application/json',
                    'Authorization': `Bearer ${token}`
                }
            }).then(response => readJson(response, "api/UnreadMessageUser/List"))
                .then(results => {
                    if (!results) {
                        return;
                    }
                    dispatch({ type: "UNREAD_MESSAGE_FETCH", payload: results });
                })
                .catch(err => console.error("getUnreadMessagesFromDatabase failed:", err))
        }
    }
}

var setUnreadMessagesFromDb = (unreadUserIds) => {
    return dispatch => {
        const token = localStorage.token;
        if (token) {
            return fetch("api/UnreadMessageUser/SaveUnreadMessages", {
                method: "POST",
                headers: {
                    'Content-Type': 'application/json',
                    Accept: 'application/json',
                    'Authorization': `Bearer ${token}`,
                },
                body: JSON.stringify(unreadUserIds)
            })
        }
    }
}

export default { 'GET_UNREAD_IDS': getUnreadMessagesFromDatabase, 'SET_UNREAD_IDS': setUnreadMessagesFromDb };


// WEBPACK FOOTER //
// ./src/actions/unread_message_actions.js


// WEBPACK FOOTER //
// ./src/actions/unread_message_actions.js